<template>
  <motion.div
    class="relatorios-page"
    :initial="{ opacity: 0 }"
    :animate="{ opacity: 1 }"
    :transition="{ duration: 0.25 }"
  >
    <motion.div class="modern-header">
      <motion.div class="header-container">
        <motion.div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ currentWorkspace?.nome || workspaceNome }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceRelatorios.breadcrumbCurrent') }}</span>
          </nav>
        </motion.div>

        <motion.div class="title-section">
          <motion.div class="title-content">
            <motion.div class="title-icon title-icon--crm">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
              </svg>
            </motion.div>
            <motion.div class="title-text">
              <h1 class="main-title">{{ t('workspaceRelatorios.title') }}</h1>
              <p class="subtitle">{{ t('workspaceRelatorios.subtitle') }}</p>
            </motion.div>
          </motion.div>
          <motion.div class="workspace-badge type-crm">
            <motion.div class="badge-icon">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </motion.div>
            <span class="badge-text">CRM</span>
          </motion.div>
        </motion.div>

        <motion.div class="actions-section">
          <motion.div class="actions-left">
            <button type="button" class="action-button secondary filtros-mob" @click="sidebarAberta = !sidebarAberta">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
              </svg>
              {{ t('workspaceRelatorios.filters') }}
            </button>
            <button type="button" class="action-button secondary" @click="abrirDrawerArquivados">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
              </svg>
              {{ t('workspaceRelatorios.archived') }}
              <span v-if="totalArquivados > 0" class="arq-badge">{{ totalArquivados }}</span>
            </button>
          </motion.div>
          <motion.div class="actions-right">
            <button
              type="button"
              class="action-button secondary"
              :disabled="exportandoPdf || loading || !!erro"
              @click="exportarRelatorioPdf"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              {{ exportandoPdf ? t('workspaceRelatorios.exportPdfGenerating') : t('workspaceRelatorios.exportPdf') }}
            </button>
            <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
              </svg>
              {{ t('workspaceRelatorios.back') }}
            </button>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>

    <motion.div class="page-content">
      <motion.div class="layout">
        <aside class="sidebar" :class="{ open: sidebarAberta }">
          <motion.div class="sidebar-inner">
            <motion.div class="sidebar-intro">
              <motion.div class="sidebar-intro-head">
                <span class="sidebar-intro-icon-wrap sidebar-intro-icon-wrap--crm" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
                  </svg>
                </span>
                <motion.div class="sidebar-intro-text">
                  <strong>{{ t('workspaceRelatorios.filtersTitle') }}</strong>
                  <p>{{ t('workspaceRelatorios.filtersHint') }}</p>
                </motion.div>
              </motion.div>
              <motion.div class="sidebar-intro-actions">
                <button type="button" class="btn-apply-filter btn-apply-filter--crm" :disabled="loading" @click="aplicarFiltros">
                  <svg class="btn-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>{{ loading ? t('workspaceRelatorios.applying') : t('workspaceRelatorios.applyFilters') }}</span>
                </button>
                <button type="button" class="btn-clear-filter" @click="limparFiltros">
                  <span>{{ t('workspaceRelatorios.clear') }}</span>
                </button>
              </motion.div>
            </motion.div>

            <div class="sidebar-filtros-scroll">
            <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.origem }">
              <button
                type="button"
                class="sec-title sec-title-toggle"
                :aria-expanded="filtroSecAberta.origem"
                @click="toggleFiltroSec('origem')"
              >
                <span class="sec-ico">📍</span>
                <span class="sec-title-label">{{ t('workspaceRelatorios.origin') }}</span>
                <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
              <div v-show="filtroSecAberta.origem" class="filtro-sec-body">
              <motion.div class="pill-row">
                <button
                  type="button"
                  class="filter-pill"
                  :class="{ active: !filtros.origem }"
                  @click="filtros.origem = ''"
                >
                  {{ t('workspaceRelatorios.allOrigins') }}
                </button>
                <button
                  v-for="o in origensLead"
                  :key="o.id"
                  type="button"
                  class="filter-pill filter-pill--origem"
                  :class="{ active: filtros.origem === o.origem }"
                  @click="filtros.origem = filtros.origem === o.origem ? '' : o.origem"
                >
                  <LeadSourceIcons
                    v-if="o.icone"
                    :name="getLeadSourceIcon(o.icone)"
                    class="filter-pill-ico"
                  />
                  {{ o.origem }}
                </button>
              </motion.div>
              <p v-if="!origensLead.length" class="muted small">
                {{ t('workspaceRelatorios.noOriginConfigured') }}
              </p>
              </div>
            </section>

            <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.usuarios }">
              <button
                type="button"
                class="sec-title sec-title-toggle"
                :aria-expanded="filtroSecAberta.usuarios"
                @click="toggleFiltroSec('usuarios')"
              >
                <span class="sec-ico">👤</span>
                <span class="sec-title-label">{{ t('workspaceRelatorios.assignedUsers') }}</span>
                <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
              <div v-show="filtroSecAberta.usuarios" class="filtro-sec-body">
              <motion.div class="chip-list">
                <label
                  v-for="u in workspaceUsers"
                  :key="'u-' + u.id"
                  class="filter-chip"
                  :class="{ active: filtros.usuarioAtribuidoIds.includes(u.id) }"
                >
                  <input v-model="filtros.usuarioAtribuidoIds" type="checkbox" :value="u.id" class="sr-only" />
                  <span class="chip-avatar">
                    <img
                      v-if="resolveAvatarUrl(u.fotoPerfil)"
                      :src="resolveAvatarUrl(u.fotoPerfil)"
                      :alt="u.nomeCompleto"
                      class="chip-avatar-img"
                    />
                    <span v-else class="chip-avatar-fallback">{{ userInitials(u.nomeCompleto) }}</span>
                  </span>
                  <span class="chip-label">{{ u.nomeCompleto }}</span>
                </label>
              </motion.div>
              <p v-if="!workspaceUsers.length" class="muted small">{{ t('workspaceRelatorios.noUsers') }}</p>
              </div>
            </section>

            <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.tags }">
              <button
                type="button"
                class="sec-title sec-title-toggle"
                :aria-expanded="filtroSecAberta.tags"
                @click="toggleFiltroSec('tags')"
              >
                <span class="sec-ico">🏷️</span>
                <span class="sec-title-label">{{ t('workspaceRelatorios.tags') }}</span>
                <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
              <div v-show="filtroSecAberta.tags" class="filtro-sec-body">
              <motion.div v-for="cat in categoriasTags" :key="cat.id" class="tag-cat-block">
                <p class="tag-cat-title">{{ cat.nome }}</p>
                <motion.div class="tags-list">
                  <button
                    v-for="tag in cat.tags || []"
                    :key="tag.id"
                    type="button"
                    class="tag-filter-item"
                    :class="{ selected: filtros.tagIds.includes(tag.id) }"
                    :style="{ backgroundColor: tag.cor || '#6366f1' }"
                    @click="toggleTag(tag.id)"
                  >
                    <span class="tag-icon" :style="{ backgroundColor: tag.cor || '#6366f1' }">
                      {{ getTagEmoji(tag.icone) }}
                    </span>
                    <span class="tag-name" :style="{ color: getTextColor(tag.cor) }">{{ tag.nome }}</span>
                  </button>
                </motion.div>
              </motion.div>
              <p v-if="!categoriasTags.length" class="muted small">{{ t('workspaceRelatorios.noTagsConfigured') }}</p>
              </div>
            </section>

            <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.periodo }">
              <button
                type="button"
                class="sec-title sec-title-toggle"
                :aria-expanded="filtroSecAberta.periodo"
                @click="toggleFiltroSec('periodo')"
              >
                <span class="sec-ico">📅</span>
                <span class="sec-title-label">{{ t('workspaceRelatorios.entryPeriod') }}</span>
                <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
              <div v-show="filtroSecAberta.periodo" class="filtro-sec-body">
              <p class="sec-hint">{{ t('workspaceRelatorios.entryPeriodHint') }}</p>
              <motion.div class="datepicker-field">
                <label class="field-lbl">{{ t('workspaceRelatorios.from') }}</label>
                <VueDatePicker v-model="periodoInicioDate" v-bind="dpOpts" :placeholder="t('workspaceRelatorios.dateStart')" />
              </motion.div>
              <motion.div class="datepicker-field">
                <label class="field-lbl">{{ t('workspaceRelatorios.to') }}</label>
                <VueDatePicker v-model="periodoFimDate" v-bind="dpOpts" :placeholder="t('workspaceRelatorios.dateEnd')" />
              </motion.div>
              </div>
            </section>
            </div>
          </motion.div>
        </aside>

        <main ref="relatorioMainRef" class="main">
          <div v-if="loading" class="panel-card muted">{{ t('workspaceRelatorios.loading') }}</div>
          <motion.div v-else-if="erro" class="panel-card erro">{{ erro }}</motion.div>
          <template v-else>
            <motion.div class="kpis">
              <motion.div class="kpi">
                <span class="kpi-icon" aria-hidden="true">📊</span>
                <motion.div>
                  <span class="kpi-lbl">{{ t('workspaceRelatorios.kpiLeads') }}</span>
                  <span class="kpi-val">{{ totalLeadsAtivos }}</span>
                </motion.div>
              </motion.div>
              <motion.div class="kpi">
                <span class="kpi-icon" aria-hidden="true">💰</span>
                <motion.div>
                  <span class="kpi-lbl">{{ t('workspaceRelatorios.kpiPotential') }}</span>
                  <MoneyAmount :value="valorPotencialTotal" class="kpi-val" />
                </motion.div>
              </motion.div>
            </motion.div>

            <motion.section class="panel-card">
              <motion.div class="panel-head">
                <h2>{{ t('workspaceRelatorios.totalsByTag') }}</h2>
                <span class="panel-badge panel-badge--crm">{{ t('workspaceRelatorios.tagsCount', { count: totaisPorTag.length }) }}</span>
              </motion.div>
              <motion.div class="tags-list tags-list--main">
                <span
                  v-for="t in totaisPorTag"
                  :key="t.tagId"
                  class="tag-item tag-item--readonly"
                  :style="{ backgroundColor: t.cor || '#6366f1' }"
                >
                  <span class="tag-icon" :style="{ backgroundColor: t.cor || '#6366f1' }">
                    {{ getTagEmoji(findTagMeta(t.tagId)?.icone) }}
                  </span>
                  <span class="tag-name" :style="{ color: getTextColor(t.cor) }">{{ t.nome }}</span>
                  <span class="tag-count" :style="{ color: getTextColor(t.cor) }">
                    {{ t.quantidadeLeads }} · <MoneyAmount :value="t.valorPotencial" size="sm" tag="span" />
                  </span>
                </span>
                <span v-if="!totaisPorTag.length" class="empty-hint">{{ t('workspaceRelatorios.noTagsInFilter') }}</span>
              </motion.div>
            </motion.section>

            <motion.div class="panel-card panel-card--crm">
              <motion.div class="panel-head">
                <motion.div class="panel-head-left">
                  <span class="panel-head-icon" aria-hidden="true">📋</span>
                  <motion.div>
                    <h2>{{ t('workspaceRelatorios.byColumn') }}</h2>
                    <p class="panel-subtitle">{{ t('workspaceRelatorios.byColumnSubtitle') }}</p>
                  </motion.div>
                </motion.div>
                <span class="panel-badge panel-badge--crm">{{ t('workspaceRelatorios.columnsCount', { count: colunaCards.length }) }}</span>
              </motion.div>

              <motion.div v-if="colunaCards.length" class="fin-dashboard">
                <motion.div
                  v-for="card in colunaCards"
                  :key="card.colunaId"
                  class="fin-stat-card"
                  :style="{
                    '--fin-coluna-cor': card.pal.bar,
                    borderTop: `3px solid ${card.pal.bar}`
                  }"
                >
                  <motion.div class="fin-stat-top">
                    <span
                      class="fin-stat-icon"
                      :style="{ background: card.pal.bg, color: card.pal.bar }"
                    >📌</span>
                    <span class="fin-stat-qtd">{{ t('workspaceRelatorios.leadsCount', { count: card.qtd }) }}</span>
                  </motion.div>
                  <span class="fin-stat-label">{{ card.colunaNome }}</span>
                  <motion.div
                    class="fin-stat-bar-wrap"
                    :style="{ background: card.pal.bg }"
                  >
                    <div
                      class="fin-stat-bar"
                      :style="{ width: card.pctVal + '%' }"
                    ></div>
                  </motion.div>
                  <span class="fin-stat-pct">{{ t('workspaceRelatorios.pctValueQty', { pctVal: card.pctVal, pctQtd: card.pctQtd }) }}</span>
                  <MoneyAmount :value="card.val" class="fin-stat-value" />
                </motion.div>
              </motion.div>
              <p v-else class="empty-hint">{{ t('workspaceRelatorios.noActiveLeads') }}</p>

              <motion.div v-if="colunaCards.length" class="fin-total-row">
                <span>Total no filtro</span>
                <strong>{{ totalLeadsAtivos }} leads · <MoneyAmount :value="valorPotencialTotal" size="sm" tag="span" /></strong>
              </motion.div>
            </motion.div>

            <motion.section class="panel-card panel-card--full panel-card--usuarios">
              <motion.div class="panel-head">
                <motion.div class="panel-head-left">
                  <span class="panel-head-icon">👤</span>
                  <motion.div>
                    <h2>{{ t('workspaceRelatorios.leadsByUser') }}</h2>
                    <p class="panel-subtitle">{{ t('workspaceRelatorios.leadsByUserSubtitle') }}</p>
                  </motion.div>
                </motion.div>
                <span class="panel-badge panel-badge--crm">
                  <MoneyAmount :value="totalValorUsuarios" size="sm" tag="span" /> · {{ t('workspaceRelatorios.usersSummary', { count: totaisPorUsuario.length }) }}
                </span>
              </motion.div>
              <p v-if="!totaisPorUsuario.length" class="empty-hint">
                {{ t('workspaceRelatorios.noAssignedLeads') }}
              </p>
              <ul v-else class="usuarios-dashboard">
                <li
                  v-for="(u, idx) in totaisPorUsuario"
                  :key="u.usuarioId"
                  class="usuario-card"
                >
                  <span class="usuario-rank">{{ idx + 1 }}</span>
                  <span class="usuario-avatar">
                    <img
                      v-if="resolveAvatarUrl(u.fotoPerfil)"
                      :src="resolveAvatarUrl(u.fotoPerfil)"
                      :alt="u.nome"
                      class="usuario-avatar-img"
                    />
                    <span v-else class="usuario-avatar-fallback">{{ userInitials(u.nome) }}</span>
                  </span>
                  <div class="usuario-bar-col">
                    <div class="usuario-bar-top">
                      <span class="usuario-nome">{{ u.nome }}</span>
                      <strong class="usuario-stats">
                        {{ u.quantidadeLeads }} {{ u.quantidadeLeads === 1 ? t('workspaceRelatorios.lead') : t('workspaceRelatorios.leads') }} · <MoneyAmount :value="u.valorPotencial" size="sm" tag="span" />
                      </strong>
                    </div>
                    <div class="usuario-bar-wrap">
                      <motion.div
                        class="usuario-bar"
                        :style="{ width: barWidthUsuario(u.valorPotencial) }"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </motion.section>

            <motion.section class="panel-card panel-card--leads">
              <motion.div class="panel-head">
                <h2>{{ t('workspaceRelatorios.leadsFound') }}</h2>
                <span class="panel-badge panel-badge--crm">
                  {{ t('workspaceRelatorios.pageFilterSummary', { page: leadsLista.length, total: totalLeadsAtivos }) }}
                </span>
              </motion.div>
              <p v-if="!leadsLista.length" class="empty-hint">{{ t('workspaceRelatorios.noLeadsMatch') }}</p>
              <motion.div v-else class="leads-grid">
                <div
                  v-for="lead in leadsLista"
                  :key="lead.id"
                  class="lead-report-wrap"
                >
                  <LeadCard
                    :lead="lead"
                    :show-tags-expanded="true"
                    :show-business-info="true"
                    :show-users="true"
                    :show-schedule="true"
                    :show-attachments="true"
                    :show-created-at="true"
                    :show-updated-at="true"
                    :workspace-tags="categoriasTags"
                    :workspace-users="workspaceUsers"
                    :workspace-motivos="workspaceMotivos"
                    @open-detail="abrirLead"
                  />
                </div>
              </motion.div>
              <motion.div v-if="totalPages > 1" class="paginacao">
                <button type="button" class="btn-ghost" :disabled="page <= 0 || loading" @click="irPagina(page - 1)">
                  {{ t('workspaceRelatorios.prev') }}
                </button>
                <span class="muted">{{ t('workspaceRelatorios.pageOf', { current: page + 1, total: totalPages }) }}</span>
                <button type="button" class="btn-ghost" :disabled="page >= totalPages - 1 || loading" @click="irPagina(page + 1)">
                  {{ t('workspaceRelatorios.next') }}
                </button>
              </motion.div>
            </motion.section>
          </template>
        </main>
      </motion.div>
    </motion.div>

    <ArchivedItemsDrawer
      :open="drawerArquivados"
      :title="t('workspaceRelatorios.archivedTitle')"
      :hint="t('workspaceRelatorios.archivedHint')"
      :loading="loadingArquivados"
      :items="arquivados"
      :total="totalArquivados"
      :page="arquivadosPage"
      :page-size="ARCHIVED_PAGE_SIZE"
      :total-pages="arquivadosTotalPages"
      :fields="archivedLeadFields"
      :empty-text="t('workspaceRelatorios.archivedEmpty')"
      :busy-id="busyId"
      @close="drawerArquivados = false"
      @desarquivar="desarquivar"
      @page-change="carregarArquivados"
    />



    <LeadDetailModal
      v-if="showLeadDetailModal"
      :is-open="showLeadDetailModal"
      :lead="selectedLead"
      @close="showLeadDetailModal = false"
      @lead-updated="onLeadAtualizado"
    />
  </motion.div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { motion } from 'motion-v'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { useWorkspaceStore } from '../stores/workspace'
import api from '../services/api'
import { getTagIcon } from '../utils/iconMapper'
import { datePickerLocaleFor } from '../utils/datePickerLocale'
import { getLeadSourceIcon } from '../utils/leadSourceIconMapper'
import LeadSourceIcons from '../components/icons/LeadSourceIcons.vue'
import LeadCard from '../components/LeadCard.vue'
import LeadDetailModal from '../components/LeadDetailModal.vue'
import ArchivedItemsDrawer from '../components/ArchivedItemsDrawer.vue'
import MoneyAmount from '../components/MoneyAmount.vue'

const LEADS_PAGE_SIZE = 20

const { t, locale } = useI18n()
const route = useRoute()
const workspaceStore = useWorkspaceStore()

const workspaceId = computed(() => Number(route.params.id))
const workspaceNome = computed(() => workspaceStore.currentWorkspace?.nome || t('workspaceDashboard.defaultName'))
const currentWorkspace = computed(() => workspaceStore.currentWorkspace)

const loading = ref(false)
const erro = ref('')
const dados = ref({})
const sidebarAberta = ref(false)

const filtroSecAberta = reactive({
  origem: true,
  usuarios: true,
  tags: true,
  periodo: true
})

const toggleFiltroSec = (key) => {
  filtroSecAberta[key] = !filtroSecAberta[key]
}

const workspaceUsers = ref([])
const categoriasTags = ref([])
const origensLead = ref([])
const workspaceMotivos = ref([])
const page = ref(0)

const archivedLeadFields = computed(() => [
  { key: 'nome', label: t('workspaceRelatorios.fieldName'), primary: true },
  { key: 'valorEstimado', label: t('workspaceRelatorios.fieldValue'), format: 'money' },
  { key: 'origem', label: t('workspaceRelatorios.origin') }
])

const ARCHIVED_PAGE_SIZE = 30

const drawerArquivados = ref(false)
const loadingArquivados = ref(false)
const arquivados = ref([])
const arquivadosPage = ref(0)
const arquivadosTotalPages = ref(0)
const busyId = ref(null)
const totalArquivados = ref(0)

const relatorioMainRef = ref(null)
const exportandoPdf = ref(false)

const showLeadDetailModal = ref(false)
const selectedLead = ref(null)

function primeiroDiaMes () {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
}

function ultimoDiaMes () {
  const d = new Date()
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0)
  return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}`
}

const filtros = reactive({
  origem: '',
  usuarioAtribuidoIds: [],
  tagIds: [],
  periodoInicio: primeiroDiaMes(),
  periodoFim: ultimoDiaMes()
})

const dpOpts = computed(() => ({
  enableTimePicker: false,
  format: 'dd/MM/yyyy',
  previewFormat: 'dd/MM/yyyy',
  locale: datePickerLocaleFor(locale.value),
  autoApply: true,
  teleport: true
}))

function parseYmd (str) {
  if (!str) return null
  const parts = String(str).split('T')[0].split('-').map(Number)
  if (parts.length < 3 || !parts[0]) return null
  return new Date(parts[0], parts[1] - 1, parts[2])
}

function toYmd (date) {
  if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) return ''
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const periodoInicioDate = computed({
  get: () => parseYmd(filtros.periodoInicio),
  set: (v) => { filtros.periodoInicio = toYmd(v) }
})
const periodoFimDate = computed({
  get: () => parseYmd(filtros.periodoFim),
  set: (v) => { filtros.periodoFim = toYmd(v) }
})

const DEFAULT_COLUNA_COR = '#4f46e5'

const normalizeHexColor = (hex) => {
  if (!hex || typeof hex !== 'string') return DEFAULT_COLUNA_COR
  let c = hex.trim()
  if (!c.startsWith('#')) c = `#${c}`
  if (/^#[0-9a-fA-F]{3}$/.test(c)) {
    c = `#${c[1]}${c[1]}${c[2]}${c[2]}${c[3]}${c[3]}`
  }
  return /^#[0-9a-fA-F]{6}$/.test(c) ? c : DEFAULT_COLUNA_COR
}

const hexToRgba = (hex, alpha = 0.15) => {
  const bar = normalizeHexColor(hex)
  const r = parseInt(bar.slice(1, 3), 16)
  const g = parseInt(bar.slice(3, 5), 16)
  const b = parseInt(bar.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

const paletteFromColumnColor = (cor) => {
  const bar = normalizeHexColor(cor)
  return { bg: hexToRgba(bar, 0.15), bar }
}

const totalLeadsAtivos = computed(() => Number(dados.value.totalAtivosFiltrados) || 0)
const valorPotencialTotal = computed(() => Number(dados.value.valorPotencialTotal) || 0)

const totaisPorTag = computed(() => dados.value.totaisPorTag || [])
const totaisPorUsuario = computed(() => dados.value.totaisPorUsuario || [])
const leadsLista = computed(() => dados.value.leads || [])
const totalPages = computed(() => Number(dados.value.totalPages) || 0)

const maxValorUsuario = computed(() => {
  const list = totaisPorUsuario.value
  if (!list.length) return 1
  return Math.max(...list.map((u) => Number(u.valorPotencial) || 0), 1)
})

const totalValorUsuarios = computed(() =>
  totaisPorUsuario.value.reduce((s, u) => s + (Number(u.valorPotencial) || 0), 0)
)

const barWidthUsuario = (valor) => {
  const max = maxValorUsuario.value
  const v = Number(valor) || 0
  if (max <= 0) return '0%'
  return `${Math.max(4, Math.round((v / max) * 100))}%`
}

const findTagMeta = (tagId) => {
  for (const cat of categoriasTags.value || []) {
    const tag = (cat.tags || []).find((t) => t.id === tagId)
    if (tag) return tag
  }
  return null
}

const colunaCards = computed(() => {
  const rows = dados.value.porColuna || []
  const totalQtd = totalLeadsAtivos.value || rows.reduce((s, r) => s + (Number(r.quantidade) || 0), 0)
  const totalVal = valorPotencialTotal.value || rows.reduce((s, r) => s + (Number(r.valorTotal) || 0), 0)
  return rows.map((r) => {
    const qtd = Number(r.quantidade) || 0
    const val = Number(r.valorTotal) || 0
    const cor = r.colunaCor || r.cor
    return {
      colunaId: r.colunaId,
      colunaNome: r.colunaNome || '—',
      qtd,
      val,
      pctQtd: totalQtd > 0 ? Math.round((qtd / totalQtd) * 100) : 0,
      pctVal: totalVal > 0 ? Math.round((val / totalVal) * 100) : 0,
      pal: paletteFromColumnColor(cor)
    }
  })
})

const isLightColor = (hex) => {
  if (!hex || typeof hex !== 'string') return true
  const c = hex.replace('#', '')
  if (c.length < 6) return true
  const r = parseInt(c.slice(0, 2), 16)
  const g = parseInt(c.slice(2, 4), 16)
  const b = parseInt(c.slice(4, 6), 16)
  return ((r * 299) + (g * 587) + (b * 114)) / 1000 > 128
}

const getTextColor = (backgroundColor) => (isLightColor(backgroundColor) ? '#000000' : '#FFFFFF')
const getTagEmoji = (iconValue) => getTagIcon(iconValue)

const userInitials = (nome) => {
  if (!nome) return '?'
  const parts = String(nome).trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

const resolveAvatarUrl = (url) => {
  if (!url) return null
  const clean = String(url).trim()
  if (!clean) return null
  if (/^https?:\/\//i.test(clean) || clean.startsWith('data:')) return clean
  if (clean.startsWith('/')) {
    const base = (api.defaults.baseURL || '').replace(/\/+$/, '')
    return `${base}${clean}`
  }
  return clean
}

const toggleTag = (tagId) => {
  const idx = filtros.tagIds.indexOf(tagId)
  if (idx >= 0) filtros.tagIds.splice(idx, 1)
  else filtros.tagIds.push(tagId)
}

const montarQs = () => {
  const p = new URLSearchParams()
  if (filtros.origem) p.set('origem', filtros.origem)
  if (filtros.usuarioAtribuidoIds.length) {
    p.set('usuarioAtribuidoIds', filtros.usuarioAtribuidoIds.join(','))
  }
  if (filtros.tagIds.length) p.set('tagIds', filtros.tagIds.join(','))
  if (filtros.periodoInicio) p.set('periodoInicio', filtros.periodoInicio)
  if (filtros.periodoFim) p.set('periodoFim', filtros.periodoFim)
  p.set('page', String(page.value))
  p.set('size', String(LEADS_PAGE_SIZE))
  const s = p.toString()
  return s ? `?${s}` : ''
}

const carregarUsuariosETags = async () => {
  try {
    const [usersRes, cfgRes] = await Promise.all([
      api.get(`/workspace-acesso/workspace/${workspaceId.value}`),
      api.get(`/workspace-config/${workspaceId.value}/configuracoes`)
    ])
    const usersRaw = Array.isArray(usersRes.data) ? usersRes.data : []
    workspaceUsers.value = usersRaw.map((u) => ({
      id: u.usuarioId ?? u.id,
      nomeCompleto: u.usuarioNome ?? u.nomeCompleto ?? u.nome,
      fotoPerfil: u.usuarioFotoPerfil ?? u.fotoPerfil ?? null
    }))
    categoriasTags.value = cfgRes.data?.categorias || []
    origensLead.value = cfgRes.data?.origensLead || []
    workspaceMotivos.value = cfgRes.data?.motivosAgendamento || []
    if (filtros.origem && !origensLead.value.some((o) => o.origem === filtros.origem)) {
      filtros.origem = ''
    }
  } catch {
    workspaceUsers.value = []
    categoriasTags.value = []
    origensLead.value = []
    workspaceMotivos.value = []
  }
}

const carregar = async () => {
  loading.value = true
  erro.value = ''
  sidebarAberta.value = false
  try {
    await workspaceStore.loadWorkspace(workspaceId.value)
    const res = await api.get(`/leads/workspace/${workspaceId.value}/relatorio-crm${montarQs()}`)
    dados.value = res.data || {}
    totalArquivados.value = dados.value.totalArquivados ?? 0
  } catch (e) {
    erro.value = e.response?.data?.error || e.message || t('workspaceRelatorios.errors.load')
    dados.value = {}
    totalArquivados.value = 0
  } finally {
    loading.value = false
  }
}

const aplicarFiltros = () => {
  page.value = 0
  carregar()
}

const limparFiltros = () => {
  filtros.origem = ''
  filtros.usuarioAtribuidoIds = []
  filtros.tagIds = []
  filtros.periodoInicio = primeiroDiaMes()
  filtros.periodoFim = ultimoDiaMes()
  page.value = 0
  carregar()
}

const irPagina = (p) => {
  page.value = p
  carregar()
}

const abrirLead = (lead) => {
  selectedLead.value = lead
  showLeadDetailModal.value = true
}

const onLeadAtualizado = async () => {
  await carregar()
  if (selectedLead.value?.id && dados.value.leads) {
    const atualizado = dados.value.leads.find((l) => l.id === selectedLead.value.id)
    if (atualizado) selectedLead.value = atualizado
  }
}

const montarQsArquivados = (p) => {
  const params = new URLSearchParams()
  if (filtros.origem) params.set('origem', filtros.origem)
  if (filtros.usuarioAtribuidoIds.length) {
    params.set('usuarioAtribuidoIds', filtros.usuarioAtribuidoIds.join(','))
  }
  if (filtros.tagIds.length) params.set('tagIds', filtros.tagIds.join(','))
  if (filtros.periodoInicio) params.set('periodoInicio', filtros.periodoInicio)
  if (filtros.periodoFim) params.set('periodoFim', filtros.periodoFim)
  params.set('page', String(p))
  params.set('size', String(ARCHIVED_PAGE_SIZE))
  return `?${params.toString()}`
}

const carregarArquivados = async (p = 0) => {
  loadingArquivados.value = true
  arquivadosPage.value = p
  try {
    const res = await api.get(
      `/leads/workspace/${workspaceId.value}/arquivados${montarQsArquivados(p)}`
    )
    arquivados.value = res.data?.arquivados || []
    totalArquivados.value = res.data?.totalArquivados ?? 0
    arquivadosTotalPages.value = Number(res.data?.totalPages) || 0
    if (arquivadosTotalPages.value > 0 && p >= arquivadosTotalPages.value) {
      await carregarArquivados(arquivadosTotalPages.value - 1)
    }
  } catch {
    arquivados.value = []
    totalArquivados.value = 0
    arquivadosTotalPages.value = 0
  } finally {
    loadingArquivados.value = false
  }
}

const abrirDrawerArquivados = async () => {
  drawerArquivados.value = true
  await carregarArquivados(0)
}

const desarquivar = async (lead) => {
  if (!lead?.id) return
  busyId.value = lead.id
  const paginaAtual = arquivadosPage.value
  try {
    await api.put(`/leads/${lead.id}/desarquivar`)
    await carregar()
    const proxima =
      arquivados.value.length <= 1 && paginaAtual > 0 ? paginaAtual - 1 : paginaAtual
    await carregarArquivados(proxima)
  } catch (e) {
    erro.value = e.response?.data?.error || t('workspaceRelatorios.errors.unarchive')
  } finally {
    busyId.value = null
  }
}

const exportarRelatorioPdf = async () => {
  const target = relatorioMainRef.value
  if (!target || loading.value || erro.value) return

  exportandoPdf.value = true
  try {
    await nextTick()
    const previousMaxHeight = target.style.maxHeight
    const previousOverflow = target.style.overflow
    target.style.maxHeight = 'none'
    target.style.overflow = 'visible'

    const canvas = await html2canvas(target, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      windowWidth: target.scrollWidth,
      windowHeight: target.scrollHeight,
      logging: false
    })

    target.style.maxHeight = previousMaxHeight
    target.style.overflow = previousOverflow

    const imgData = canvas.toDataURL('image/png')
    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const imgWidth = pageWidth
    const imgHeight = (canvas.height * imgWidth) / canvas.width
    let heightLeft = imgHeight
    let position = 0

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    heightLeft -= pageHeight

    while (heightLeft > 0) {
      position = heightLeft - imgHeight
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
      heightLeft -= pageHeight
    }

    const wsSlug = String(workspaceNome.value || 'workspace').replace(/[^\w\-]+/g, '_')
    const dt = new Date().toISOString().slice(0, 10)
    pdf.save(`relatorio-crm-${wsSlug}-${dt}.pdf`)
  } catch (e) {
    console.error('Erro ao exportar PDF do relatório CRM:', e)
    window.alert(t('workspaceRelatorios.errors.pdfExport'))
  } finally {
    exportandoPdf.value = false
  }
}

onMounted(async () => {
  await carregarUsuariosETags()
  await carregar()
})

watch(workspaceId, async () => {
  page.value = 0
  await carregarUsuariosETags()
  await carregar()
})
</script>

<style scoped>
.relatorios-page {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.modern-header {
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
}

.header-container {
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.breadcrumb-section { display: flex; align-items: center; }
.breadcrumb { display: flex; align-items: center; gap: 8px; font-size: 14px; flex-wrap: wrap; }
.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 14px;
}
.breadcrumb-item:hover { background: var(--bg-hover); color: var(--text-primary); }
.breadcrumb-separator { color: var(--text-muted); margin: 0 4px; }
.breadcrumb-current { color: var(--text-primary); font-weight: 600; }

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.title-content { display: flex; align-items: center; gap: 16px; }
.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  color: white;
}
.title-icon--crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}
.main-title { font-size: 28px; font-weight: 700; margin: 0; }
.subtitle { font-size: 16px; color: var(--text-secondary); margin: 0; }

.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
}
.workspace-badge.type-crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.actions-section {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}
.actions-left, .actions-right { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.actions-right { margin-left: auto; }

.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.action-button.primary {
  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);
  color: white;
}
.action-button.secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}
.action-button:disabled { opacity: 0.55; cursor: not-allowed; }
.arq-badge {
  background: rgba(16, 185, 129, 0.2);
  color: #059669;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
}

.page-content { padding: 24px; box-sizing: border-box; }
.filtros-mob { display: none; }

.layout {
  display: grid;
  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}
.main { min-width: 0; }

.sidebar {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
}

.sidebar-inner {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  padding: 0;
}

.sidebar-intro {
  flex-shrink: 0;
  margin: 12px 12px 8px;
  border-radius: 4px;
  background: linear-gradient(145deg, var(--bg-primary) 0%, rgba(16, 185, 129, 0.08) 100%);
  border: 1px solid rgba(16, 185, 129, 0.22);
  overflow: hidden;
}
.sidebar-intro-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
}
.sidebar-intro-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.sidebar-intro-icon-wrap--crm {
  background: linear-gradient(135deg, #10b981, #059669);
}
.sidebar-intro-icon-wrap svg { width: 20px; height: 20px; }
.sidebar-intro-text strong { font-size: 14px; }
.sidebar-intro-text p { margin: 4px 0 0; font-size: 12px; color: var(--text-secondary); }
.sidebar-intro-actions {
  padding: 0 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.btn-apply-filter,
.btn-clear-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  padding: 7px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  min-height: 0;
  height: auto;
  cursor: pointer;
  box-sizing: border-box;
}
.btn-apply-filter {
  border: none;
  color: #fff;
  box-shadow: 0 1px 6px rgba(16, 185, 129, 0.3);
}
.btn-apply-filter--crm {
  background: linear-gradient(135deg, #10b981, #059669);
}
.btn-apply-filter:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.btn-clear-filter {
  border: 1px solid var(--border-primary);
  background: transparent;
  color: var(--text-secondary);
}
.btn-clear-filter:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}
.sidebar-intro-actions .btn-ico {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.sidebar-filtros-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding-bottom: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar {
  width: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-filtros-scroll::-webkit-scrollbar-thumb {
  background-color: var(--border-primary);
  border-radius: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--border-hover);
}

.filtro-sec {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-primary);
}

.filtro-sec--collapsed {
  padding-bottom: 10px;
}

.sec-title,
.sec-title-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.sec-title-toggle {
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  transition: color 0.15s ease;
}

.sec-title-toggle:hover {
  color: var(--text-primary);
}

.sec-title-toggle:focus-visible {
  outline: 2px solid rgba(16, 185, 129, 0.45);
  outline-offset: 2px;
  border-radius: 4px;
}

.sec-title-label {
  flex: 1;
  min-width: 0;
}

.sec-chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-tertiary);
  transition: transform 0.2s ease;
}

.filtro-sec--collapsed .sec-title-toggle {
  margin-bottom: 0;
}

.filtro-sec--collapsed .sec-chevron {
  transform: rotate(-90deg);
}

.sec-ico {
  font-size: 14px;
}
.sec-hint { font-size: 12px; color: var(--text-secondary); margin: 0 0 8px; }
.pill-row { display: flex; flex-wrap: wrap; gap: 8px; }
.filter-pill {
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  font-size: 12px;
  cursor: pointer;
}
.filter-pill.active {
  background: linear-gradient(135deg, #10b981, #059669);
  border-color: transparent;
  color: #fff;
}
.filter-pill--origem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.filter-pill-ico {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.chip-list { display: flex; flex-direction: column; gap: 8px; }
.filter-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  cursor: pointer;
}
.filter-chip.active {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.12);
}
.chip-avatar {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  overflow: hidden;
}
.chip-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.chip-avatar-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chip-label { font-size: 13px; }

.tag-cat-block { margin-bottom: 14px; }
.tag-cat-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 8px;
}
.tags-list { display: flex; flex-wrap: wrap; gap: 8px; }
.tag-filter-item {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 2px solid transparent;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}
.tag-filter-item.selected {
  border-color: #fff;
  box-shadow: 0 0 0 2px #10b981;
}
.tag-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.tag-name { font-size: 11px; font-weight: 700; text-transform: uppercase; }

.datepicker-field { margin-bottom: 10px; }
.field-lbl {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}
.kpi {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: linear-gradient(145deg, var(--bg-secondary), var(--bg-primary));
}
.kpi-icon { font-size: 28px; }
.kpi-lbl { display: block; font-size: 12px; color: var(--text-secondary); margin-bottom: 4px; }
.kpi-val { font-size: 24px; font-weight: 800; }

.panel-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
}
.panel-card--crm {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, rgba(16, 185, 129, 0.04) 100%);
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.panel-head-left { display: flex; align-items: center; gap: 14px; }
.panel-head h2 { margin: 0; font-size: 18px; }
.panel-head-icon { font-size: 28px; }
.panel-subtitle { margin: 4px 0 0; font-size: 13px; color: var(--text-secondary); }
.panel-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
}
.panel-badge--crm {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.fin-dashboard {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}
.fin-stat-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px 20px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
}
.fin-stat-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.fin-stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fin-stat-qtd {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--bg-secondary);
  white-space: nowrap;
}
.fin-stat-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-secondary);
}
.fin-stat-value {
  display: block;
  width: 100%;
  margin-top: 2px;
  font-size: 22px;
  font-weight: 800;
  text-align: right;
  line-height: 1.2;
  color: var(--text-primary);
  white-space: nowrap;
}
.fin-stat-bar-wrap {
  height: 6px;
  background: var(--bg-secondary);
  border-radius: 999px;
  overflow: hidden;
  margin-top: 8px;
}
.fin-stat-bar {
  height: 100%;
  border-radius: 999px;
  min-width: 4px;
  background: var(--fin-coluna-cor, #6366f1);
}
.fin-stat-pct { font-size: 11px; color: var(--text-secondary); margin-top: 4px; display: block; }
.fin-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--border-primary);
  font-size: 14px;
  color: var(--text-secondary);
  flex-wrap: wrap;
  gap: 8px;
}
.fin-total-row strong { font-size: 18px; color: var(--text-primary); }

.tags-list--main {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.tag-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 6px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tag-item--readonly { cursor: default; padding-right: 12px; }
.tag-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}
.tag-name {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.tag-count {
  font-size: 11px;
  font-weight: 800;
  margin-left: 4px;
  opacity: 0.95;
  white-space: nowrap;
}

.panel-card--usuarios {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, rgba(16, 185, 129, 0.04) 100%);
}
.panel-card--full { width: 100%; }
.usuarios-dashboard {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.usuario-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
}
.usuario-rank {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: var(--bg-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: var(--text-secondary);
  flex-shrink: 0;
}
.usuario-card:nth-child(1) .usuario-rank {
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
}
.usuario-avatar {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}
.usuario-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.usuario-avatar-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.usuario-bar-col { flex: 1; min-width: 0; }
.usuario-bar-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.usuario-nome {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}
.usuario-stats {
  font-size: 13px;
  font-weight: 800;
  color: #059669;
  flex-shrink: 0;
}
.usuario-bar-wrap {
  height: 10px;
  background: var(--bg-secondary);
  border-radius: 999px;
  overflow: hidden;
}
.usuario-bar {
  height: 100%;
  background: linear-gradient(90deg, #10b981, #059669);
  border-radius: 999px;
  min-width: 4px;
  transition: width 0.4s ease;
}

.panel-card--leads {
  margin-bottom: 24px;
}
.leads-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.lead-report-wrap {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.lead-report-wrap :deep(.lead-card) {
  cursor: pointer;
  max-width: 100%;
}
.paginacao {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.muted { color: var(--text-secondary); }
.small { font-size: 12px; }
.erro { color: #b91c1c; }
.empty-hint { color: var(--text-secondary); padding: 12px 0; }

.btn-ghost {
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  cursor: pointer;
}
table { width: 100%; border-collapse: collapse; font-size: 14px; }
th, td { text-align: left; padding: 10px 8px; border-bottom: 1px solid var(--border-primary); }

@media (max-width: 900px) {
  .title-section { flex-direction: column; align-items: flex-start; }
  .actions-section { flex-direction: column; align-items: stretch; }
  .actions-right { margin-left: 0; }
  .layout { grid-template-columns: 1fr; }
  .filtros-mob { display: flex; }
  .sidebar {
    display: none;
    position: fixed;
    z-index: 1500;
    left: 16px;
    right: 16px;
    top: 80px;
    max-height: calc(100vh - 96px);
    overflow: hidden;
  }

  .sidebar.open {
    display: block;
  }

  .sidebar.open .sidebar-inner {
    max-height: calc(100vh - 96px);
  }
}
</style>
